import { AmaxPayOpenBankingBankAccount, ConsentStatus } from 'shared/data/webApp/v1';

export const bankAccountComparator = (a: AmaxPayOpenBankingBankAccount, b: AmaxPayOpenBankingBankAccount) => {
    if (
        (a.xeroBankAccount && !b.xeroBankAccount) ||
        (a.consent.status === ConsentStatus.Authorized && b.consent.status !== ConsentStatus.Authorized)
    ) {
        return -1;
    } else if (
        (!a.xeroBankAccount && b.xeroBankAccount) ||
        (a.consent.status !== ConsentStatus.Authorized && b.consent.status === ConsentStatus.Authorized)
    ) {
        return 1;
    }

    return 0;
};
